import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import PerfectScrollBar from "react-perfect-scrollbar";

import GlobalStyle from "../components/GlobalStyle";
import MainContent from "./application layout components/MainContent";

const ContentWrapper = styled("div")({
  display: "flex",
  height: "100%",
  background: "rgb(255, 255, 255)",
});

const MainContentWrapper = styled("div")({
  flex: 1,
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
});

export default function AuthLayout() {
  return (
    <Fragment>
      <CssBaseline />
      <GlobalStyle />

      <ContentWrapper>
        <MainContentWrapper>
          <MainContent />
        </MainContentWrapper>
      </ContentWrapper>
    </Fragment>
  );
}
